import { PlanConfig, TopUpConfig } from '@/types/billing.types';

/**
 * Central billing configuration.
 * Update prices/credits here without touching UI or API code.
 */

export const CREDIT_ACTIONS = {
  COPILOT_PER_MINUTE: 1,
  RECON_BRIEF: 5,
  POST_CALL_CRM_SYNC: 5,
} as const;

export const ANNUAL_DISCOUNT = 0.20; // 20% off monthly price

export const PLANS: PlanConfig[] = [
  {
    id: 'solo',
    name: 'Solo',
    monthlyPrice: 1900,
    annualPrice: Math.round(1900 * (1 - ANNUAL_DISCOUNT)),
    creditsPerCycle: 450,
    seats: 1,
    description: 'Perfect for individual closers. ~10 full calls per month.',
    stripePriceMonthly: import.meta.env.VITE_STRIPE_PRICE_SOLO_MONTHLY ?? '',
    stripePriceAnnual: import.meta.env.VITE_STRIPE_PRICE_SOLO_ANNUAL ?? '',
  },
  {
    id: 'closer',
    name: 'Closer',
    monthlyPrice: 4900,
    annualPrice: Math.round(4900 * (1 - ANNUAL_DISCOUNT)),
    creditsPerCycle: 1350,
    seats: 1,
    description: 'For serious closers running ~30 full calls per month.',
    isPopular: true,
    stripePriceMonthly: import.meta.env.VITE_STRIPE_PRICE_CLOSER_MONTHLY ?? '',
    stripePriceAnnual: import.meta.env.VITE_STRIPE_PRICE_CLOSER_ANNUAL ?? '',
  },
  {
    id: 'team',
    name: 'Team',
    monthlyPrice: 8900,
    annualPrice: Math.round(8900 * (1 - ANNUAL_DISCOUNT)),
    creditsPerCycle: 5400, // 2 seats × 2,700
    seats: 2,
    description: 'Includes 2 seats. Each member gets 2,700 dedicated monthly credits.',
    stripePriceMonthly: import.meta.env.VITE_STRIPE_PRICE_TEAM_MONTHLY ?? '',
    stripePriceAnnual: import.meta.env.VITE_STRIPE_PRICE_TEAM_ANNUAL ?? '',
  },
];

export const TOP_UPS: TopUpConfig[] = [
  {
    id: 'topup_500',
    label: 'Starter Pack',
    credits: 500,
    price: 2500,
    stripePriceId: import.meta.env.VITE_STRIPE_PRICE_TOPUP_500 ?? '',
  },
  {
    id: 'topup_1500',
    label: 'Pro Pack',
    credits: 1500,
    price: 6000,
    stripePriceId: import.meta.env.VITE_STRIPE_PRICE_TOPUP_1500 ?? '',
  },
  {
    id: 'topup_5000',
    label: 'Power Pack',
    credits: 5000,
    price: 17500,
    stripePriceId: import.meta.env.VITE_STRIPE_PRICE_TOPUP_5000 ?? '',
  },
];

/** Formats cents to a display price string, e.g. 1900 → "$19" */
export function formatPrice(cents: number): string {
  const dollars = cents / 100;
  return dollars % 1 === 0
    ? `$${dollars.toFixed(0)}`
    : `$${dollars.toFixed(2)}`;
}
